import { getIconForTopicBySourceId } from '@klv/organisms/topics-menu/utils/functions';
import { generateClassName } from '@klv/shared/utils/functions';
import Icon from '@klv/atoms/icon';

import * as styles from './styles/topics-menu-item.module.css';

import type { ITopicsMenuItem } from './types';

const TopicsMenuItem = ({
  className,
  selected = false,
  sourceId,
  topic = '',
  url,
  ...props
}: ITopicsMenuItem) => {
  if (!topic) return null;

  return (
    <a
      href={url}
      className={generateClassName([styles.topicsMenuItem, selected && styles.selected, className])}
      {...props}
    >
      <Icon
        className={styles.topicIcon}
        fillColor="currentColor"
        iconName={getIconForTopicBySourceId(sourceId)}
        size={3}
      />
      <div className={generateClassName([styles.topicName, 'h6'])}>
        {topic}
      </div>
    </a>
  );
};

export default TopicsMenuItem;
